module.exports = __webpack_public_path__ + "static/media/2.dec2a9b3.jpg";